(function () {
  const BAR_SEL = "[data-free-ship]";
  const FILL_SEL = "[data-free-ship-fill]";
  const TEXT_SEL = "[data-free-ship-text]";

  // global persisted UI state between rerenders
  window.__fsbState = window.__fsbState || {
    total: null,
    progressPercent: null,
    textHtml: "",
    giftReached: false,
    shippingReached: false,
    allUnlocked: false,
    layoutKey: "",
    lastCartSignature: ""
  };

  function formatMoney(cents, format) {
    const value = typeof cents === "string" ? cents.replace(".", "") : String(cents);
    const number = parseInt(value, 10);
    if (!Number.isFinite(number)) return "";

    function formatWithDelimiters(amount, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      const amt = (amount / 100).toFixed(precision);
      const parts = amt.split(".");
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? dollars + decimal + parts[1] : dollars;
    }

    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = m ? m[1] : "amount";

    let formatted = "";
    switch (placeholder) {
      case "amount":
        formatted = formatWithDelimiters(number, 2, ",", ".");
        break;
      case "amount_no_decimals":
        formatted = formatWithDelimiters(number, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(number, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(number, 0, ".", ",");
        break;
      default:
        formatted = formatWithDelimiters(number, 2, ",", ".");
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function getMoneyFormatFromBar(bar) {
    return bar.getAttribute("data-money-format") || "${{amount}}";
  }

  function uppercaseGifts(text) {
    return String(text || "").replace(/\bgifts\b/gi, "GIFTS");
  }

  function highlightGiftCount(text) {
    return uppercaseGifts(text).replace(
      /\b(\d+\s+GIFTS)\b/g,
      '<span class="fsb-success-gifts">$1</span>'
    );
  }

  function isBarReadyForCoverage(bar) {
    const drawer = bar?.closest?.(".m-cart-drawer");
    return !drawer || drawer.classList.contains("m-cart-drawer--active");
  }

  function refreshLabelCoverage(bar) {
    if (!isBarReadyForCoverage(bar)) return;

    updateLabelCoverageByFill(bar);
    requestAnimationFrame(() => updateLabelCoverageByFill(bar));
    setTimeout(() => updateLabelCoverageByFill(bar), 120);
    setTimeout(() => updateLabelCoverageByFill(bar), 320);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  }

  function clampPercent(value) {
    return Math.max(0, Math.min(100, value));
  }
  function ensureLabelTextSpan(label) {
  if (!label) return null;

  let span = label.querySelector(".m-free-ship__label-text");
  if (span) return span;

  const text = label.textContent.trim();
  label.textContent = "";

  span = document.createElement("span");
  span.className = "m-free-ship__label-text";
  span.textContent = text;

  label.appendChild(span);

  return span;
}

function updateLabelCoverageByFill(bar) {
  if (!bar) return;

  const fill = bar.querySelector(FILL_SEL);
  if (!fill) return;

  const fillRect = fill.getBoundingClientRect();
  const fillRight = fillRect.right;

  const labels = Array.from(bar.querySelectorAll(".m-free-ship__label"));

  labels.forEach((label) => {
    const textEl = ensureLabelTextSpan(label);
    if (!textEl) return;

    const textRect = textEl.getBoundingClientRect();

    if (!textRect.width) {
      textEl.style.setProperty("--label-cover", "0%");
      return;
    }

    const coverPercent = clampPercent(
      ((fillRight - textRect.left) / textRect.width) * 100
    );

    textEl.style.setProperty("--label-cover", coverPercent.toFixed(2) + "%");
  });
}

function trackLabelCoverageDuringFill(bar, duration = 450) {
  if (!isBarReadyForCoverage(bar)) return;

  const start = performance.now();

  function frame(now) {
    updateLabelCoverageByFill(bar);

    if (now - start < duration) {
      requestAnimationFrame(frame);
    }
  }

  requestAnimationFrame(frame);
}

  function setMilestoneActive(el, active) {
    if (!el) return;
    el.classList.toggle("is-active", !!active);
  }

  function setMilestoneSide(el, side) {
    if (!el) return;
    el.classList.remove("is-center", "is-right");
    el.classList.add(side);
  }

  function getCartSignature(cart) {
    const total = Number(cart.total_price || 0);
    const count = Number(cart.item_count || 0);
    const items = (cart.items || []).map((item) => `${item.key}:${item.quantity}`).join("|");
    return `${total}__${count}__${items}`;
  }

  function buildStateFromCart(bar, cart) {
    const giftGoal = Number(bar.getAttribute("data-gift-goal") || 0);
    const shippingGoal = Number(bar.getAttribute("data-shipping-goal") || 0);

    if (!giftGoal && !shippingGoal) return null;

    const total = Number(cart.total_price || 0);
    const giftLabel = bar.getAttribute("data-gift-label") || "Gift";
    const shippingLabel = bar.getAttribute("data-shipping-label") || "Free Shipping";
    const moneyFormat = getMoneyFormatFromBar(bar);

    const giftReached = total >= giftGoal;
    const shippingReached = total >= shippingGoal;
    const smallerIsGift = giftGoal <= shippingGoal;

    const firstTarget =
      giftGoal <= shippingGoal
        ? { label: giftLabel, goal: giftGoal }
        : { label: shippingLabel, goal: shippingGoal };

    const secondTarget =
      giftGoal <= shippingGoal
        ? { label: shippingLabel, goal: shippingGoal }
        : { label: giftLabel, goal: giftGoal };

   // Фільтруємо тільки активні goals (> 0)
const activeGoals = [
  giftGoal > 0 ? { goal: giftGoal, label: giftLabel } : null,
  shippingGoal > 0 ? { goal: shippingGoal, label: shippingLabel } : null
].filter(Boolean).sort((a, b) => a.goal - b.goal);

const firstGoal = activeGoals[0]?.goal || 0;
const secondGoal = activeGoals[1]?.goal || 0;

let progressPercent = 0;

if (activeGoals.length === 0) {
  progressPercent = 0;
} else if (activeGoals.length === 1) {
  // тільки один milestone — лінійний прогрес 0-100%
  progressPercent = total >= firstGoal ? 100 : clampPercent((total / firstGoal) * 100);
} else {
  // два milestones
  if (total <= 0) {
    progressPercent = 0;
  } else if (total < firstGoal) {
    progressPercent = (total / firstGoal) * 50;
  } else if (total < secondGoal) {
    progressPercent = 50 + ((total - firstGoal) / (secondGoal - firstGoal)) * 50;
  } else {
    progressPercent = 100;
  }
}

    const textUnlocked = highlightGiftCount(bar.getAttribute("data-text-unlocked") || "You unlocked all rewards");
    const textAway = bar.getAttribute("data-text-away") || "You're {{amount}} away from {{label}}";

    let textHtml = "";

    if (total < firstTarget.goal) {
      const remaining = firstTarget.goal - total;
      textHtml = textAway
        .replace("{{amount}}", `<span class="fsb-amount">${formatMoney(remaining, moneyFormat)}</span>`)
        .replace("{{label}}", `<span class="fsb-reward">${firstTarget.label}</span>`);
    } else if (total < secondTarget.goal) {
      const remaining = secondTarget.goal - total;
      textHtml = textAway
        .replace("{{amount}}", `<span class="fsb-amount">${formatMoney(remaining, moneyFormat)}</span>`)
        .replace("{{label}}", `<span class="fsb-reward">${secondTarget.label}</span>`);
    } else {
      textHtml = `<span class="fsb-success">${textUnlocked}</span>`;
    }

    return {
      total,
      progressPercent: clampPercent(progressPercent),
      textHtml,
      giftReached,
      shippingReached,
      allUnlocked: giftReached && shippingReached,
      smallerIsGift,
      layoutKey: `${giftGoal}_${shippingGoal}`,
      cartSignature: getCartSignature(cart)
    };
  }

  function applyStateToBar(bar, state, animate = true) {
    if (!bar || !state) return;

    const fill = bar.querySelector(FILL_SEL);
    const text = bar.querySelector(TEXT_SEL);
    const giftEl = bar.querySelector('[data-free-ship-milestone="gift"]');
    const shippingEl = bar.querySelector('[data-free-ship-milestone="shipping"]');

const giftGoal = Number(bar.getAttribute("data-gift-goal") || 0);
const shippingGoal = Number(bar.getAttribute("data-shipping-goal") || 0);

if (giftEl) giftEl.style.display = giftGoal > 0 ? "" : "none";
if (shippingEl) shippingEl.style.display = shippingGoal > 0 ? "" : "none";

if (state.smallerIsGift) {
  setMilestoneSide(giftEl, "is-center");
  setMilestoneSide(shippingEl, "is-right");
} else {
  setMilestoneSide(shippingEl, "is-center");
  setMilestoneSide(giftEl, "is-right");
}

    setMilestoneActive(giftEl, state.giftReached);
    setMilestoneActive(shippingEl, state.shippingReached);

    bar.classList.toggle("is-gift-unlocked", state.giftReached);
    bar.classList.toggle("is-shipping-unlocked", state.shippingReached);
    bar.classList.toggle("is-all-unlocked", state.allUnlocked);

if (fill) {
  if (!animate) fill.classList.add("is-no-anim");

  fill.style.width = state.progressPercent + "%";

  if (!animate) {
    requestAnimationFrame(() => {
      fill.classList.remove("is-no-anim");
    });
  }

  if (animate) {
    trackLabelCoverageDuringFill(bar, 450);
  } else {
    refreshLabelCoverage(bar);
  }
}

    if (text) {
      text.innerHTML = state.textHtml || "";
    }
  }

  function hydrateBarsFromCache() {
    const bars = Array.from(document.querySelectorAll(BAR_SEL));
    if (!bars.length) return;

    const state = window.__fsbState;
    if (state && state.progressPercent != null) {
      bars.forEach((bar) => applyStateToBar(bar, state, false));
    }
  }

  function refreshVisibleBars() {
    const bars = Array.from(document.querySelectorAll(BAR_SEL));
    bars.forEach((bar) => refreshLabelCoverage(bar));
  }

  function applyCartToBars(cart, animate = true) {
    const bars = Array.from(document.querySelectorAll(BAR_SEL));
    if (!bars.length || !cart || cart.total_price == null) return false;

    const firstBar = bars[0];
    const prevSignature = window.__fsbState?.cartSignature;
    const nextState = buildStateFromCart(firstBar, cart);
    if (!nextState) return false;

    const shouldAnimate = animate && prevSignature !== nextState.cartSignature;

    window.__fsbState = nextState;
    bars.forEach((bar) => applyStateToBar(bar, nextState, shouldAnimate));
    return true;
  }

  function handleCartEvent(event, fallbackDelay = 40) {
    clearOpenUpdate();
    hydrateBarsFromCache();

    if (applyCartToBars(event?.detail?.cart, true)) return;

    scheduleUpdate(fallbackDelay);
  }

  let updateTimer = null;
  let openUpdateTimer = null;
  let inFlight = false;
  let lastRequestedAt = 0;
  const MIN_UPDATE_INTERVAL = 350;

  function clearOpenUpdate() {
    if (!openUpdateTimer) return;
    clearTimeout(openUpdateTimer);
    openUpdateTimer = null;
  }

  function scheduleOpenUpdate(delay = 550) {
    clearOpenUpdate();
    openUpdateTimer = setTimeout(() => {
      openUpdateTimer = null;
      scheduleUpdate(0);
    }, delay);
  }

  function scheduleUpdate(delay = 0) {
    clearTimeout(updateTimer);

    const elapsed = Date.now() - lastRequestedAt;
    const throttledDelay = Math.max(delay, MIN_UPDATE_INTERVAL - elapsed, 0);

    updateTimer = setTimeout(updateAll, throttledDelay);
  }

  async function updateAll() {
    const bars = Array.from(document.querySelectorAll(BAR_SEL));
    if (!bars.length) return;

    if (inFlight) {
      scheduleUpdate(MIN_UPDATE_INTERVAL);
      return;
    }

    inFlight = true;
    lastRequestedAt = Date.now();

    try {
      const cart = await fetchCart();
      const prevSignature = window.__fsbState?.cartSignature;
      const nextSignature = getCartSignature(cart);

      if (applyCartToBars(cart, prevSignature !== nextSignature) && prevSignature === nextSignature) {
        bars.forEach((bar) => refreshLabelCoverage(bar));
        return;
      }
    } catch (e) {
      // silent fail
    } finally {
      inFlight = false;
    }
  }

  function initObserver() {
    const target =
      document.querySelector("#MinimogCartDrawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector(".m-cart-drawer") ||
      document.body;

    if (!target || target.__fsbObserved) return;
    target.__fsbObserved = true;

    const obs = new MutationObserver((mutations) => {
      let hasBar = false;

      for (const m of mutations) {
        if (m.type !== "childList") continue;

        hasBar = Array.from(m.addedNodes || []).some((n) => {
          if (n.nodeType !== 1) return false;
          return n.matches?.(BAR_SEL) || n.querySelector?.(BAR_SEL);
        });

        if (hasBar) break;
      }

      if (hasBar) {
        // instantly paint new DOM from cached state
        hydrateBarsFromCache();

        // then verify against actual cart once
        scheduleUpdate(120);
      }
    });

    obs.observe(target, { childList: true, subtree: true });

    const drawerStateObs = new MutationObserver(() => {
      hydrateBarsFromCache();
      refreshVisibleBars();
    });

    drawerStateObs.observe(target, {
      attributes: true,
      attributeFilter: ["class", "style", "open", "aria-hidden"]
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initObserver();

    if (window.MinimogEvents?.subscribe && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, (payload) => {
        if (!applyCartToBars(payload?.cart, true)) {
          scheduleUpdate(40);
        }
      });
    }

    if (window.MinimogEvents?.subscribe && window.MinimogTheme?.pubSubEvents?.openCartDrawer) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, refreshOnDrawerOpen);
    }
  });

  document.addEventListener("cart:refresh", (event) => handleCartEvent(event, 40));

  document.documentElement.addEventListener("cart:refresh", (event) => handleCartEvent(event, 40));

  document.addEventListener("cart:updated", (event) => handleCartEvent(event, 40));

  function refreshOnDrawerOpen() {
    hydrateBarsFromCache();
    refreshVisibleBars();
    scheduleOpenUpdate();
  }

  document.addEventListener("cart:open", refreshOnDrawerOpen);

  document.addEventListener("drawer:open", refreshOnDrawerOpen);
})();
